import axios from "axios";
import {
    requestSubmitData,
    submitDataSuccess,
    submitDataFailure,
    requestSubmitAddLinksData,
    submitAddLinksDataSuccess,
    submitAddLinksDataFailure,
    // updateSessionExpiry,
} from "../../ActionCreator/home";

import { add_links_data_url, data_url } from "../../../allApiPath";


export const dataSubmit = (formData, token) => async (dispatch, getState) => {
    dispatch(requestSubmitData())

    axios.post(data_url, formData,
        {
            headers: {
                'Content-Type': 'multipart/form-data',
                // 'Content-Type': 'application/json',
                'Authorization': token,
            },
            // body: JSON.stringify(formData),
        }
    )
        .then((response) => {
            // console.log(response.data);
            dispatch(submitDataSuccess(response.data));
        }, error => {
            dispatch(submitDataFailure(error))
        })
}


export const addLinksDataSubmit = (
    date,
    title,
    url,
    selectedCategoriesOptions,
    selectedDistrict,
    selectedUpazila,
    selectedSourceTypeOption,
    comment,
    listSetSelectedTags,
    token,
) => async (dispatch, getState) => {
    dispatch(requestSubmitAddLinksData())

    axios.post(add_links_data_url, {
        date: date,
        title: title,
        source_url: url,
        categories: selectedCategoriesOptions,
        location: selectedDistrict,
        upazila: selectedUpazila,
        source_description: selectedSourceTypeOption,
        source_type: selectedSourceTypeOption,
        comment: comment,
        tags: listSetSelectedTags,
    }, {
        headers: {
            'Authorization': token,
        },
    })
        .then((response) => {
            dispatch(submitAddLinksDataSuccess(response.data));
        }, error => {
            dispatch(submitAddLinksDataFailure(error))
        })
}
